import range from 'lodash/range';

const paginate = ({
  totalResults,
  currentPage = 1,
  resultsPerPage = 10,
  pageRange = 10
}) => {
  const totalPages = Math.ceil(totalResults / resultsPerPage);

  let startPage;
  let endPage;

  if (totalPages <= pageRange) {
    // total pages less than desired range - so show all
    startPage = 1;
    endPage = totalPages;
  } else {
    const maxPagesBeforeCurrent = Math.floor(pageRange / 2);
    const maxPagesAfterCurrent = Math.ceil(pageRange / 2) - 1;

    if (currentPage <= maxPagesBeforeCurrent) {
      // currentPage near the start
      startPage = 1;
      endPage = pageRange;
    } else if (currentPage + maxPagesAfterCurrent >= totalPages) {
      // currentPage near the end
      startPage = totalPages - pageRange + 1;
      endPage = totalPages;
    } else {
      // currentPage in the middle
      startPage = currentPage - maxPagesBeforeCurrent;
      endPage = currentPage + maxPagesAfterCurrent;
    }
  }

  const startIndex = (currentPage - 1) * resultsPerPage;
  const endIndex = Math.min(startIndex + resultsPerPage - 1, totalResults - 1);
  const pages = range(startPage, endPage + 1);

  return {
    pages,
    startIndex,
    endIndex,
    totalPages,
  };
};

export default paginate;
